type FilterValueFormatter = (value: string) => string;

export function filterValuesSharingDisplayLabel(
    targetValue: string,
    allValues: ReadonlyArray<string>,
    valueFormatter: FilterValueFormatter,
    nullSentinel?: string,
): Array<string> {
    if (nullSentinel !== undefined && targetValue === nullSentinel) {
        return [nullSentinel];
    }
    const targetLabel = valueFormatter(targetValue);
    return allValues.filter((value) => {
        if (nullSentinel !== undefined && value === nullSentinel) {
            return false;
        }
        return valueFormatter(value) === targetLabel;
    });
}

export function toggleFilterValuesByDisplayLabel(
    pickerValue: string,
    selectedValues: ReadonlyArray<string> | null,
    allValues: ReadonlyArray<string>,
    valueFormatter: FilterValueFormatter,
    nullSentinel?: string,
): Array<string> | null {
    const group = filterValuesSharingDisplayLabel(pickerValue, allValues, valueFormatter, nullSentinel);
    if (selectedValues === null) {
        const groupSet = new Set(group);
        const remaining = allValues.filter((value) => groupSet.has(value) === false);
        return remaining;
    }
    const isSelected = group.some((value) => selectedValues.includes(value) === true);
    if (isSelected === true) {
        return selectedValues.filter((value) => group.includes(value) === false);
    }
    return [...selectedValues, ...group.filter((value) => selectedValues.includes(value) === false)];
}
